import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { get } from 'lodash';
import moment from 'moment';

const RagProcessingNotification = ({ notification, isRead, onClick }) => {
  const intl = useIntl();
  const data = get(notification, 'data', {});
  const isSuccess = notification.action === 'rag_url_processing_complete';
  const createdAt = get(notification, 'createdAt');

  const message = isSuccess
    ? intl.formatMessage({ id: 'succession.notifications.rag_processing.processing_complete' }, { successful: data.successful, total: data.total })
    : intl.formatMessage({ id: 'succession.notifications.rag_processing.processing_failed' }, { error: data.error || intl.formatMessage({ id: 'succession.notifications.rag_processing.unknown_error' }) });

  return (
    <div className="flex items-start gap-3" onClick={onClick}>
      {/* Icon */}
      <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
        isSuccess ? 'bg-green-100' : 'bg-red-100'
      }`}>
        {isSuccess ? (
          <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        ) : (
          <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <p className={`text-sm ${!isRead ? 'font-semibold' : 'font-normal'} text-succession-text`}>
          {message}
        </p>
        {data.titles && isSuccess && (
          <p className="text-xs text-succession-text-secondary mt-1 truncate">
            {intl.formatMessage({ id: 'succession.notifications.rag_processing.documents_label' }, { titles: data.titles })}
          </p>
        )}
        <p className="text-xs text-succession-text-secondary mt-1">
          {createdAt && moment(createdAt).fromNow()}
        </p>
      </div>
    </div>
  );
};

RagProcessingNotification.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    action: PropTypes.string.isRequired,
    data: PropTypes.object,
    createdAt: PropTypes.string,
  }).isRequired,
  isRead: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RagProcessingNotification;
